import React from "react";
import {Route, Routes} from "react-router-dom";
import {AuthLayout} from "./AuthLayout";
import {Login} from "../pages/authentication/Login";
import { GhanaCardVerificationPage } from '../pages/authentication/onboard/GhanaCardVerificationPage';
import { OneTimePinOnboard } from "../pages/authentication/onboard/OneTimePinOnboard";
import { CreatePasswordOnboard } from "../pages/authentication/onboard/CreatePasswordOnboard";
import { SuccessOnboard } from "../pages/authentication/onboard/SuccessOnboard";
import {NeedHelpPage} from "../pages/authentication/onboard/NeedHelpPage";
import PostLoginPhoneOtpPage from '../pages/authentication/onboard/PostLoginPhoneOtpPage';


export const UnAuthenticatedRoutes = () => {
    return (
        <AuthLayout>
            <Routes>
                {/* Define routes for authenticated users */}
                <Route path="/login" element={<Login />} />
                <Route path="/verify-ghana-card" element={<GhanaCardVerificationPage />} />
                <Route path="/verify-otp" element={<OneTimePinOnboard />} />
                <Route path="/create-password" element={<CreatePasswordOnboard />} />
                <Route path="/success" element={<SuccessOnboard />} />
                <Route path="/needhelp" element={<NeedHelpPage/>} />
                 <Route path="/verify-phone-otp" element={<PostLoginPhoneOtpPage />} />
            </Routes>
        </AuthLayout>
    )
}
